import { registerDesignedFormMethods } from './methods';
import Validator from './Validator';
const val = new Validator();
registerDesignedFormMethods(val);
export default val;
